import React from 'react';
import ReactDOM from 'react-dom/client';

import TravelSearchExternalForm from './TravelSearchExternalForm';

const root = ReactDOM.createRoot(
  document.getElementById('travel_search_external')
);

root.render(
  <React.StrictMode>
    <TravelSearchExternalForm />
  </React.StrictMode>
);
